document.addEventListener('DOMContentLoaded', function () {
  // Scroll-reveal
  var revealEls = document.querySelectorAll('.ilz-reveal, .ilz-reveal-stagger');
  if (revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },  { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  // Hero cursor glow
  document.querySelectorAll('.ilz-hero').forEach(function (hero) {
    var glow = hero.querySelector('.ilz-hero-glow');
    if (!glow) return;
    hero.addEventListener('mousemove', function (e) {
      var rect = hero.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      hero.style.setProperty('--ilz-gx', x + '%');
      hero.style.setProperty('--ilz-gy', y + '%');
    });
  });

  // Room pills (scroll-to-collection anchors, just handle active state visually)
  document.querySelectorAll('.ilz-room-pill').forEach(function (pill) {
    pill.addEventListener('click', function () {
      document.querySelectorAll('.ilz-room-pill').forEach(function (p) { p.classList.remove('active'); });
      pill.classList.add('active');
    });
  });

  // FAQ accordion
  document.querySelectorAll('.ilz-faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentElement;
      var wasOpen = item.classList.contains('open');
      item.parentElement.querySelectorAll('.ilz-faq-item').forEach(function (i) { i.classList.remove('open'); });
      if (!wasOpen) item.classList.add('open');
    });
  });
});
